var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('div',{staticClass:"global-loader-background"},[_c('span',{staticClass:"global-loader-helper"}),_c('img',{staticClass:"global-loader",attrs:{"src":require("@/assets/images/global_loader.svg"),"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }